import styled from 'styled-components';

import { ListButton } from '../ListButton';
import { breakpoints } from '../../constants';

interface IProps {
    showMobileMap: boolean;
}

export const MapWrapper = styled.div<IProps>`
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    left: ${({ showMobileMap }) => (showMobileMap ? 0 : '100%')};
    transition: left linear 300ms;

    ${ListButton} {
        position: absolute;
        bottom: 20px;
        right: 20px;
    }

    @media (${breakpoints.mediumMin}) {
        position: static;

        ${ListButton} {
            display: none;
        }
    }
`;
